import UserActions from "../../actions/UserActions";
import AppConstants from "../../constants/AppConstants";
import { COMMANDS } from "../../document/commands";
import DocumentStore from "../../document/DocumentStore";
import { addElement } from "../../utils/elementCreationUtils";
import { createPexelsElementContent } from "../../utils/PexelsUtils";
import BlockUpdateVO from "../../vo/BlockUpdate.mjs";

const { ELEMENT_TYPE_GRAPHIC } = AppConstants;

class PexelsSelectHandler {
  /**
   * @param {string} elementId
   * @param {import("@/types/data/Pexels.mjs").PexelsPhoto} photo
   */
  static applyPhotoToElement(elementId, photo) {
    const update = new BlockUpdateVO();

    // Pexels only serves raster images, so an svg element becomes a graphic again.
    update.addPropUpdate(elementId, { name: "type", value: ELEMENT_TYPE_GRAPHIC });
    // SET, not the default: Block.applyUpdate merges objects, which would leave
    // the previous image's provider and attribution on the new photo.
    update.addPropUpdate(elementId, {
      name: "content",
      value: createPexelsElementContent(photo),
      action: AppConstants.UPDATE_ACTION_SET,
    });

    DocumentStore.dispatch({ type: COMMANDS.UPDATE_BLOCK, payload: update });
    // Keep the element write and recents change in one undo step.
    PexelsSelectHandler.recordUse(photo);
  }

  /**
   * Adds a new image element sourced from the photo.
   * @param {import("@/types/data/Pexels.mjs").PexelsPhoto} photo
   * @param {{ containedBy?: string, blockId?: string }} [target]
   * @param {string} [clickLocation="footer"]
   */
  static createPhotoElement(photo, target = {}, clickLocation = "footer") {
    addElement(ELEMENT_TYPE_GRAPHIC, target, clickLocation, createPexelsElementContent(photo));
    PexelsSelectHandler.recordUse(photo);
  }

  /**
   * @param {import("@/types/data/Pexels.mjs").PexelsPhoto} photo
   */
  static recordUse(photo) {
    DocumentStore.dispatch({ type: COMMANDS.RECORD_RECENT_PEXELS_PHOTO, payload: photo });
    UserActions.trackPostHogEvent("pexels_image_selected", {
      photo_id: photo.id,
      photographer: photo.photographer,
    });
  }
}

export default PexelsSelectHandler;
